import _extends from "@babel/runtime-corejs3/helpers/extends";

function _createForOfIteratorHelperLoose(o, allowArrayLike) { var _context2; var it; if (typeof _Symbol === "undefined" || _getIteratorMethod(o) == null) { if (_Array$isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } it = _getIterator(o); return _bindInstanceProperty(_context2 = it.next).call(_context2, it); }

function _unsupportedIterableToArray(o, minLen) { var _context; if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = _sliceInstanceProperty(_context = Object.prototype.toString.call(o)).call(_context, 8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return _Array$from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _Array$from from "@babel/runtime-corejs3/core-js-stable/array/from";
import _Symbol from "@babel/runtime-corejs3/core-js-stable/symbol";
import _getIteratorMethod from "@babel/runtime-corejs3/core-js/get-iterator-method";
import _Array$isArray from "@babel/runtime-corejs3/core-js-stable/array/is-array";
import _getIterator from "@babel/runtime-corejs3/core-js/get-iterator";
import _bindInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/bind";
import logger from "../../../util/logger";
import React from 'react';
import * as _ from "../../../util/lodash";
import { compose } from 'react-recompose';
import cx from 'classnames';
import plyr from 'plyr';
import Hls from 'hls.js';
import { ConfigService } from "../../../services";
import { createComponent, PropTypes } from "../../../wayin-react";
import { whitelistStyles } from "../hoc";
import Image from "../image";
import { getMuxId } from "../../../util";
var status = {
  FAILED: 'failed',
  PENDING: 'pending',
  READY: 'ready'
};
var error = {
  NETWORK_ERROR: 'fatal network error encountered, trying to recover',
  MEDIA_ERROR: 'fatal media error encountered, try to recover'
};
var MuxVideo = createComponent({
  displayName: 'MuxVideo',
  propTypes: {
    src: PropTypes.string.isRequired,
    poster: PropTypes.string,
    status: PropTypes.oneOf(_valuesInstanceProperty(_).call(_, status)),
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  },
  defaultProps: {
    poster: undefined,
    status: status.READY,
    width: undefined
  },
  state: {
    isMediaReady: {
      value: false,
      updater: 'setIsMediaReady'
    },
    _status: {
      value: function value(p) {
        return p.status;
      },
      updater: 'setStatus'
    },
    player: {
      value: undefined,
      updater: 'setPlayer'
    }
  },
  handlers: {
    updatePoster: function updatePoster(props) {
      return function (_poster) {
        if (props.player && props.player.length > 0) {
          for (var _iterator = _createForOfIteratorHelperLoose(props.player), _step; !(_step = _iterator()).done;) {
            var playerEl = _step.value;
            playerEl.poster = _poster;
          }
        }
      };
    },
    destroyPlayer: function destroyPlayer(props) {
      return function () {
        // player may not exist if the video status !== ready
        if (props.player && props.player.length > 0) {
          for (var _iterator2 = _createForOfIteratorHelperLoose(props.player), _step2; !(_step2 = _iterator2()).done;) {
            var playerEl = _step2.value;
            playerEl.destroy();
          }

          props.setPlayer(undefined);
          if (window.hls) window.hls.destroy();
        }
      };
    },
    createPlayer: function createPlayer(props) {
      return function () {
        var refs = props.refs,
            src = props.src,
            setIsMediaReady = props.setIsMediaReady,
            setStatus = props.setStatus,
            setPlayer = props.setPlayer,
            _status = props._status;
        var _playerOptions = {
          seekTime: 5,
          controls: [// 'airplay', // Airplay (currently Safari only)
          // 'captions', // Toggle captions
          'current-time', // The current time of playback
          // 'download', // Show a download button with a link to either the current source or a custom URL you specify in your options
          // 'duration', // The full duration of the media
          // 'fast-forward', // Fast forward by the seek time (default 10 seconds)
          'fullscreen', // Toggle fullscreen
          'mute', // Toggle mute
          // 'pip', // Picture-in-picture (currently Safari only)
          'play', // Play/pause playback
          'play-large', // The large play button in the center
          'progress', // The progress bar and scrubber for playback and buffering
          // 'restart', // Restart playback
          // 'rewind', // Rewind by the seek time (default 10 seconds)
          // 'settings', // Settings menu
          'volume' // Volume control
          ]
        };
        setPlayer(plyr.setup("#plyr-player-" + getPlayerId(props), _playerOptions));

        if (_status === status.READY) {
          if (!Hls.isSupported()) {
            refs.videoNode.src = src;
            setIsMediaReady(true);
          } else {
            // For more Hls.js options, see https://github.com/dailymotion/hls.js
            var hls = new Hls({
              autoStartLoad: true
            });
            hls.loadSource(src);
            hls.attachMedia(refs.videoNode);
            window.hls = hls;
            hls.on(Hls.Events.MANIFEST_LOADED, function () {
              setIsMediaReady(true);
            });
            hls.on(Hls.Events.MEDIA_ATTACHED, function () {
              hls.loadSource(src);
            });
            hls.on(Hls.Events.ERROR, function (event, data) {
              var errorType = data.type;
              var errorFatal = data.fatal;

              if (errorFatal) {
                setIsMediaReady(false);
                setStatus(status.FAILED);

                switch (errorType) {
                  case Hls.ErrorTypes.NETWORK_ERROR:
                    logger.warn(error.NETWORK_ERROR, true);
                    hls.startLoad();
                    break;

                  case Hls.ErrorTypes.MEDIA_ERROR:
                    logger.warn(error.MEDIA_ERROR, true);
                    hls.recoverMediaError();
                    break;

                  default:
                    // cannot recover
                    hls.destroy();
                    break;
                }
              }
            });
          }
        }
      };
    }
  },
  lifecycles: {
    UNSAFE_componentWillUpdate: function UNSAFE_componentWillUpdate(nextProps) {
      // this will ensure the poster gets set when the poster prop changes or when the player has fully initialised
      if (!_.isEqual(nextProps.poster, this.props.poster) || !_.isEqual(nextProps.player, this.props.player)) {
        this.props.updatePoster(nextProps.poster);
      }
    },
    componentDidMount: function componentDidMount() {
      this.props.createPlayer();
      this.props.updatePoster(this.props.poster);
    },
    componentWillUnmount: function componentWillUnmount() {
      this.props.destroyPlayer();
    }
  },
  refs: 'videoNode',
  render: function render(props) {
    var _id = getPlayerId(props);

    var className = cx('ck', 'mux-video', props._status);

    var _style = _extends({}, props.width && {
      width: props.width
    }); // when a video has been deleted, our asset ref will still look valid and have a status of "ready".
    // we therefore have to render the video component into the page hidden
    // and update it's visibility once we can be sure the media is ready to use.


    var videoClassName = cx('video__wrapper', {
      hidden: !props.isMediaReady
    });
    return /*#__PURE__*/React.createElement("div", {
      className: className
    }, props._status !== status.READY ? /*#__PURE__*/React.createElement(Image, {
      size: "fluid",
      src: _valuesInstanceProperty(ConfigService).call(ConfigService).assetUrls.staticResourceURL + "/static/img/misc/video-" + props._status + ".svg"
    }) : null, /*#__PURE__*/React.createElement("div", {
      className: videoClassName,
      style: _style
    }, /*#__PURE__*/React.createElement("video", {
      ref: props.setVideoNode,
      id: "plyr-player-" + _id,
      src: props.src
    })));
  }
});

var getPlayerId = function getPlayerId(props) {
  return props.id || getMuxId(props.src);
};

export default compose(whitelistStyles())(MuxVideo);
//# sourceMappingURL=mux-video.js.map